import { container } from 'tsyringe';
import { createFurnhomeUserManagementCommunication } from './furnhome-user-management-communication';

// Laedt die Communication eines Moduls, registriert sie und laedt danach die Komponente. Die
// Komponente braucht die Communication schon, wenn sie erzeugt wird.
type ModuleLoaderType = () => Promise<void>;

// Der Code der Module kommt erst beim ersten Oeffnen. Wer das Recht nicht hat, oeffnet ein Modul
// nie - SET-CONTENT und APPLY-ROUTE lenken vorher auf home um -, und sein Code kommt nie an.
// Die Pakete sind im rollup-Build external: ihr import() bleibt stehen, und der Vite-Build des
// Clients legt pro Modul eine eigene Datei an.
const MODULE_LOADERS: Readonly<Record<string, ModuleLoaderType>> = {
  administration: async () => {
    const { AdministrationCommunicationToken, BrowserAdministrationCommunication } = await import('@dh-software/administration-communication');
    // Zweiter Wert ist die Basis des Websockets: derselbe Pfad, den furnhomes Websocket-Proxy annimmt.
    // Ein Pfad statt einer absoluten Adresse, damit die Verbindung auf furnhomes eigener Adresse bleibt.
    container.register(AdministrationCommunicationToken, { useValue: new BrowserAdministrationCommunication('/api/administration', '/api/administration/') });
    await import('@dh-software/administration-component');
  },
  usermanagement: async () => {
    const { UserManagementCommunication, UserManagementCommunicationToken } = await import('@dh-software/opus-x-communication');
    const FurnhomeUserManagementCommunication = createFurnhomeUserManagementCommunication(UserManagementCommunication);
    container.register(UserManagementCommunicationToken, { useValue: new FurnhomeUserManagementCommunication('/api/usermanagement') });
    await import('@dh-software/opus-x-usermanagement-component');
  },
  // furnport ist ein eigenes, separates Monorepo. Seine Pakete kommen wie die der anderen Module
  // ueber die gitignorierte `override.json` aus dem lokalen Checkout.
  furnport: async () => {
    const { BrowserFurnportCommunication, FurnportCommunicationToken } = await import('@dh-software/furnport-communication');
    // Selbst erzeugt statt vom Container gebaut: die Klasse nimmt ihre Basis-URL als einfachen
    // String und traegt keine Decorator-Metadaten, aus denen tsyringe sie bauen koennte.
    container.register(FurnportCommunicationToken, { useValue: new BrowserFurnportCommunication('/api/furnport') });
    await import('@dh-software/furnport-component');
  },
};

// Pro Modul das eine Laden. Ein zweiter Besuch - auch nach einem Logout - laedt nichts neu, und ein
// fehlgeschlagenes Laden bleibt fehlgeschlagen, bis die Seite neu geladen wird.
const moduleLoadings = new Map<string, Promise<void>>();

export function loadModule(moduleName: string): Promise<void> {
  const moduleLoader = MODULE_LOADERS[moduleName];
  if (!moduleLoader) {
    return Promise.resolve();
  }

  let moduleLoading = moduleLoadings.get(moduleName);
  if (!moduleLoading) {
    moduleLoading = moduleLoader();
    moduleLoadings.set(moduleName, moduleLoading);
  }
  return moduleLoading;
}
